module.exports = __webpack_public_path__ + "assets/img/kv-e8c99e83.jpg";